{
  "pt": {
    "todo_v2": {
      "actions": {
        "confirm": "Marcar como concluída",
        "create": "Tarefa",
        "reopen": "Reabrir",
        "update": "Editar tarefa"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Funcionário",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignees": "Responsáveis",
        "created_at": "Criado",
        "due_date": "Prazo",
        "project": "Projeto",
        "status": "Estado",
        "todo_group": "Tarefa",
        "unit": "Unidade"
      },
      "labels": {
        "add_assignee": "Adicionar responsável…",
        "add_customers": "Adicionar clientes",
        "completed": "Concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "group_already_added": "Esta tarefa já foi adicionada a esta unidade.",
        "my_todos": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_todos": "Ainda não há tarefas.",
        "no_todos_group": "Ainda não há tarefas neste grupo.",
        "no_todos_unit": "Ainda não há tarefas para esta unidade.",
        "publish_all": "Publicar tudo",
        "publish_customers": "Publicar para os clientes de cada unidade",
        "published": "Publicado",
        "required": "Este campo é obrigatório",
        "select_group": "Selecione uma tarefa",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa.",
        "uploaded_documents": "Documentos carregados"
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "pending": "Pendente"
      },
      "toasts": {
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "uncompleted": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
